export function invertFootData(pressurePoints: { x: number, y: number, z: number }[][], invert: { x: boolean, y: boolean }): { x: number, y: number, z: number }[][] {

    let totalSensorsPerRow = 48.0;

    let newInvertedPoints: { x: number, y: number, z: number }[][] = [];

    pressurePoints.map((capture) => {
        let newCapture = [];

        capture.map((point) => {
            if (invert.x) {
                point.x = totalSensorsPerRow - point.x
            }
            if (invert.y) {
                point.y = totalSensorsPerRow - point.y
            }

            newCapture.push({
                x: point.x,
                y: point.y,
                z: point.z
            });

        })
        newInvertedPoints.push(newCapture)
    })

    return pressurePoints;
}